import { TextAlign, WhiteSpace } from '../../../layout/constants'
import { WHITE_SPACE, NEW_LINE, WORD } from '../constants'
import { calculateLineHeight } from '../utils'

export default function textLayout(tokens, style, options = {}) {
  const lineHeight = calculateLineHeight(style)
  const { width } = options
  const hasWidth = width !== undefined
  const isNoWrap = style.whiteSpace === WhiteSpace.NOWRAP
  const canWrap = !isNoWrap && hasWidth === true

  let x = 0
  let y = 0
  let xBuffer = 0
  let row = []
  let finalWidth = 0
  let hasRTLWords = false

  const newLine = () => {
    if (hasRTLWords) {
      for (const token of row) {
        token.x = x - token.x - token.getWidth()
      }
    }

    if (hasWidth) {
      const diff = Math.max(width - x, 0)
      let offset = 0
      switch (style.textAlign) {
        case TextAlign.CENTER:
          offset = diff / 2
          break
        case TextAlign.RIGHT:
          offset = diff
          break
      }
      if (offset) {
        for (const token of row) {
          token.x += offset
        }
      }
    }

    if (x > finalWidth) {
      finalWidth = x
    }
    x = 0
    y += lineHeight
    row.length = 0
    xBuffer = 0
    hasRTLWords = false
  }

  for (const token of tokens) {
    const tokenType = token.getType()

    if (tokenType === NEW_LINE) {
      newLine()
      continue
    }

    if (tokenType === WORD && token.isRTL) {
      hasRTLWords = true
    }

    const isWhiteSpace = tokenType === WHITE_SPACE

    const tokenWidth = token.getWidth()
    const estimatedWidth = x + xBuffer + tokenWidth
    const isOverflow = canWrap && row.length !== 0 && estimatedWidth > width

    if (isOverflow) {
      newLine()
    }

    if (isWhiteSpace) {
      if (row.length !== 0) {
        xBuffer += tokenWidth
      }
      continue
    }

    x += xBuffer
    xBuffer = 0
    token.x = x
    token.y = y
    x += tokenWidth
    row.push(token)
  }
  newLine()

  return { width: finalWidth, height: y }
}
